import loadable from "@loadable/component";

export const Todo = loadable(() => import("./todo"));
